module.exports = __webpack_public_path__ + "img/car_icon.f74e8eb3.svg";